import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Paper } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWandMagicSparkles, faSearch } from '@fortawesome/free-solid-svg-icons';
import './SearchModeToggle.scss';

export enum SearchMode {
  AI = 'ai',
  Places = 'places'
}

interface SearchModeToggleProps {
  mode: SearchMode;
  onModeChange: (mode: SearchMode) => void;
  className?: string;
}

const SearchModeToggle: React.FC<SearchModeToggleProps> = ({ mode, onModeChange, className }) => {
  return (
    <Box className={`search-mode-toggle ${className || ''}`}>
      <Paper className="search-mode-toggle-paper">
        <ToggleButtonGroup
          value={mode}
          exclusive
          onChange={(_, newMode) => newMode && onModeChange(newMode)}
          size="small"
          className="search-mode-toggle-group"
        >
          <ToggleButton value={SearchMode.AI} aria-label="AI Search">
            <Box className="search-mode-icon-container">
              <FontAwesomeIcon icon={faWandMagicSparkles} size="sm" />
              AI
            </Box>
          </ToggleButton>
          <ToggleButton value={SearchMode.Places} aria-label="Search">
            <Box className="search-mode-icon-container">
              <FontAwesomeIcon icon={faSearch} size="sm" />
              Search
            </Box>
          </ToggleButton>
        </ToggleButtonGroup>
      </Paper>
    </Box>
  );
};

export default SearchModeToggle;
